// src/pages/BedTypesPage.js

import React from 'react';

const BedTypesPage = () => {
  return (
    <div>
      <h1>Bed Types</h1>
      <p>This is the Bed Types management page. Here you can view and manage different types of beds available in your hotel system.</p>

      {/* Dummy list of bed types */}
      <ul>
        <li>King Size Bed</li>
        <li>Queen Size Bed</li>
        <li>Twin Bed</li>
        <li>Double Bed</li>
        <li>Single Bed</li>
      </ul>

      <button>Add New Bed Type</button>
    </div>
  );
};

export default BedTypesPage;
